import cookie from "react-cookies";
import { RIMS_COOKIE_STG_CONSTANTS } from "../constants";

const MENU_RELATED_RESOURCE_PATH = "/resources/menu/related-resource";

export function getResolvedTenantId(requestUrl?: string): string {
  if (requestUrl?.includes(MENU_RELATED_RESOURCE_PATH)) {
    return String(
      cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_TENANT_ID) || ""
    ).trim();
  }

  const urlTenantId = new URLSearchParams(window.location.search).get(
    "currentTenantId"
  );
  if (urlTenantId?.trim()) {
    return urlTenantId.trim();
  }

  return String(
    cookie.load(RIMS_COOKIE_STG_CONSTANTS.AC_TENANT_ID) ||
      cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_TENANT_ID) ||
      ""
  ).trim();
}
